
<template>
    <modal
      name="fieldsUpdateModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="750px"
      height="auto"
    >
      <div class="v-modal profile_details_modal error-modal-space">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Passport Fields</h2>
          <span  @click="hideMe()">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form @submit.prevent data-vv-scope="fieldsUpdateForm"> 
          <div class="form-container">
            <div class="vx-row" @click="errorMsg = ''">
                <immiInput :allowUpperCase="true" :display="false" :fieldsArray="[]" datatype="alpha_num|max:15" cid="benfpassportNumber" formscope="fieldsUpdateForm" v-model="passportObj.passportNumber"  :fieldName="'passportNumber'"  :required="true"  label="Passport Number" placeHolder="Passport Number" />
                <datepickerField :display="false"  :fieldsArray="[]" :validationRequired="true" v-model="passportObj.passportIssuedDate"   :fieldName="'passportIssuedDate'"  formscope="fieldsUpdateForm"  :dateEnableTo="new Date()" label="Passport Issued Date" />
                <datepickerField :display="false" :fieldsArray="[]" :dateEnableFrom="new Date()" :validationRequired="true" v-model="passportObj.passportExpiryDate"  :fieldName="'passportExpiryDate'"  formscope="fieldsUpdateForm"  label="Passport Expiry Date" />
                <selectField   :display="false" :fieldsArray="[]" @input="passportObj.passportIssuedCountry = passportObj.passportIssuedCountryDetails.id" :required="true" :optionslist="countries" v-model="passportObj.passportIssuedCountryDetails"   :fieldName="'passportIssuedCountry'" cid="passportIssuedCountry" formscope="fieldsUpdateForm"  label="Country of Passport Issued" placeHolder="Country of Passport Issued" />
                <div class="vx-col md:w-full" v-if="false">
                    <div class="form_group">
                        <fileUploadNote />
                        <label class="form_label">Passport<em>*</em></label>
                        <div class="vs-component relative mb-1">                  
                        <file-upload
                            :multiple="false"
                            :hideSelected="true"
                            v-model="passportObj.documents"
                            class="file-upload-input file_upload justify-center"
                            name="documentsUpload"
                            :accept="allDocEntity"
                            @updateData="updateData" >
                        </file-upload>
                        </div>

                        <input  type="hidden" v-validate="'required'" data-vv-as="Document" name="passportDocument"  v-model="getDocsVal" />
                        <span class="text-danger text-sm" v-show="errors.has('fieldsUpdateForm.passportDocument')">*Documents are required</span>
                        <ul class="uploaded-list note_uploads" v-if="checkProperty(passportObj.documents, 'length') > 0">
                        <template v-for="(file, fileindex) in passportObj.documents">
                            <vs-chip type="button" @click="removeFiles(fileindex)" :key="fileindex"  v-if="file.status !== false"  closable >{{ file.name }}</vs-chip>
                        </template>
                        </ul>
                    </div>
                </div>
                <!-- <fileUploadNote :fileNote="true" /> -->
                <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'bendocslist'" :docslist="docslist" 
                :petition="petition" formscope="fieldsUpdateForm" :fieldsArray="[]" 
                v-model="documents" :fieldName="''" :showTitle="false" ></casedocumentslist>
            </div>
            <div v-show="errorMsg">
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
                >{{ errorMsg }}</vs-alert
              >
            </div>
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"/></span>
  
            <vs-button color="dark"  @click="hideMe()"  class="cancel" type="filled">Cancel</vs-button>
            <vs-button  color="success"  :disabled="loading"  @click="submitForm()" class="save" type="filled">Update </vs-button>
          </div>        
        </form>
      </div>
    </modal>
  </template>
  <script>
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import moment from "moment";
  //import FileUpload from "vue-upload-component/src";
  import { EyeIcon } from 'vue-feather-icons'
  import docType from "@/views/common/docType.vue"
  import fileUploadNote from "@/views/common/fileUploadNote.vue";
  import FileUpload from "@/views/FileUpload.vue";
  import casedocumentslist from "@/views/common/casedocuments.vue";
  export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
        casedocumentslist,
        datepickerField,
        selectField,
        immiInput,
        docType,
        EyeIcon,
        FileUpload,
        fileUploadNote
    },
    methods: {
        init(){
            if(this.updateAction === 'PASSPORT_BENEFICIARY'){
                let docList=[
                    {
                        key: 'docs_passport',
                        fileUploading:false,
                        fieldName: 'passport',
                        required: true,
                        label: 'Passport- First page with photo and last page with address'
                    },
                    {
                        required: true,
                        fileUploading:false,
                        key: 'docs_passport_visa_i94',
                        fieldName: 'passportVisaI94',
                        label: 'Passport- First page with photo, Visa page and last page with address'
                    },
                ];
                this.docslist = _.cloneDeep(docList);
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'passportNumber')){
                    this.passportObj['passportNumber'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'passportNumber')
                }
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'passportExpiryDate')){
                    this.passportObj['passportExpiryDate'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'passportExpiryDate')
                }
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'passportIssuedDate')){
                    this.passportObj['passportIssuedDate'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'passportIssuedDate')
                }
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'passportIssuedCountryDetails')){
                    this.passportObj['passportIssuedCountryDetails'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'passportIssuedCountryDetails');
                    this.passportObj['passportIssuedCountry'] = this.checkProperty(this.petition['beneficiaryInfo'] ,'passportIssuedCountryDetails', 'id')
                }
                if(this.checkProperty(this.petition,'documents' ,'passport')){
                    this.documents['passport'] = this.checkProperty(this.petition,'documents' ,'passport')
                }
                if(this.checkProperty(this.petition,'documents' ,'passport')){
                    this.documents['passportVisaI94'] = this.checkProperty(this.petition,'documents' ,'passportVisaI94')
                }
            }
            if(this.updateAction === 'PASSPORT_SPOUSE'){
                let docList = [
                    {
                        required: true,
                        key: 'spouse_docs_passport',
                        fieldName: 'passport',
                        label: 'Passport- First page with photo, Visa page and last page with address'
                    },
                ];
                this.docslist = _.cloneDeep(docList);
                if(this.checkProperty(this.petition, 'dependentsInfo') && this.checkProperty(this.petition, 'dependentsInfo', 'spouse')){
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportNumber')){
                        this.passportObj['passportNumber'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportNumber')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportExpiryDate')){
                        this.passportObj['passportExpiryDate'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportExpiryDate')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportIssuedDate')){
                        this.passportObj['passportIssuedDate'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportIssuedDate')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportIssuedCountryDetails')){
                        this.passportObj['passportIssuedCountryDetails'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'passportIssuedCountryDetails');
                        this.passportObj['passportIssuedCountry'] = this.checkProperty(this.petition['dependentsInfo']['spouse'],'passportIssuedCountryDetails', 'id')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo']['spouse'],'documents' ,'passport')){
                        this.documents['passport'] = this.checkProperty(this.petition['dependentsInfo']['spouse'],'documents' ,'passport')
                    }
                }
               
            }
            if(this.updateAction === 'PASSPORT_CHILD'){
                let docList = [
                    {
                        required: true,
                        key: 'child_docs_passport',
                        fieldName: 'passport',
                        label: 'Passport- First page with photo, Visa page and last page with address'
                    },
                ];
                this.docslist = _.cloneDeep(docList);
                // reminderDetails
                if(this.checkProperty(this.petition, 'dependentsInfo') && this.checkProperty(this.petition, 'dependentsInfo', 'childrens') && this.checkProperty(this.petition['dependentsInfo'], 'childrens', 'length')>0){
                    let findObj = _.find(this.petition['dependentsInfo']['childrens'], {'_id':this.checkProperty(this.reminderDetails, 'caseDetails', 'childId')});
                    if(findObj){
                        if(this.checkProperty(findObj ,'passportNumber')){
                            this.passportObj['passportNumber'] = this.checkProperty(findObj, 'passportNumber')
                        }
                        if(this.checkProperty(findObj ,'passportExpiryDate')){
                            this.passportObj['passportExpiryDate'] = this.checkProperty(findObj ,'passportExpiryDate')
                        }
                        if(this.checkProperty(findObj ,'passportIssuedDate')){
                            this.passportObj['passportIssuedDate'] = this.checkProperty(findObj ,'passportIssuedDate')
                        }
                        if(this.checkProperty(findObj ,'passportIssuedCountryDetails')){
                            this.passportObj['passportIssuedCountryDetails'] = this.checkProperty(findObj ,'passportIssuedCountryDetails');
                            this.passportObj['passportIssuedCountry'] = this.checkProperty(findObj,'passportIssuedCountryDetails', 'id')
                        }
                        if(this.checkProperty(findObj,'documents' ,'passport')){
                            this.documents['passport'] = this.checkProperty(findObj,'documents' ,'passport')
                        }
                    }
                }
            }
        },
        emitUploadingAction(data){

        },
        getCountries(){
            this.$store.dispatch("getcountries").then((response) => {
                this.countries = response;
            });
        },
        updateData(docs){
            this.passportObj['documents'] = docs;
        },
        removeFiles(index){
            this.passportObj['documents'].splice(index ,1);
        },
        hideMe() {
            this.$emit("hidePassportModal");
            this.$modal.hide("fieldsUpdateModal");
        },
        submitForm(){
            this.$validator.validateAll("fieldsUpdateForm").then((result) => {
                if(result){
                    let Payload ={
                        caseId:this.checkProperty(this.reminderDetails, 'caseDetails', 'caseId')
                    };
                    if(this.updateAction === 'PASSPORT_BENEFICIARY'){
                        Payload = Object.assign(Payload,{'beneficiaryInfo':this.passportObj});
                        Payload = Object.assign(Payload,{'documents':this.documents});
                        Payload = Object.assign(Payload,{'benfType':'BENEFICIARY'});
                        Payload = Object.assign(Payload,{'action':'PASSPORT_BENEFICIARY'});
                    }
                    if(this.updateAction === 'PASSPORT_SPOUSE'){
                        Payload = Object.assign(Payload,{'dependentsInfo':{}});
                        Payload = Object.assign(Payload['dependentsInfo'],{'spouse':this.passportObj});
                        Payload = Object.assign(Payload,{'spouseDocuments':this.documents});
                        Payload = Object.assign(Payload,{'benfType':'SPOUSE'});
                        Payload = Object.assign(Payload,{'action':'PASSPORT_SPOUSE'});
                    }
                    if(this.updateAction === 'PASSPORT_CHILD'){
                        Payload = Object.assign(Payload,{'dependentsInfo':{}});
                        Payload = Object.assign(Payload['dependentsInfo'],{'children':this.passportObj});
                        Payload = Object.assign(Payload,{'childDocuments':this.documents});
                        Payload = Object.assign(Payload,{'benfType':'CHILD'});
                        Payload = Object.assign(Payload,{'action':'PASSPORT_CHILD'});
                        Payload = Object.assign(Payload,{'childId':this.checkProperty(this.reminderDetails, 'caseDetails', 'childId')});
                    }
                    let path = '/petition/update-brief-info';
                    this.$store.dispatch('commonAction', {data:Payload, path:path}).then((res)=>{
                        this.hideMe();
                    }).catch((err)=>{
                        this.errorMsg = err
                    })
                }
            })
        },
    },
    watch: {
      
    },
    mounted() {
        // console.log(JSON.stringify(this.reminderDetails), 'this.reminderDetails')
        this.getCountries();
        this.init();
        this.$modal.show("fieldsUpdateModal");
    },
    data: () => ({
        countries:[],
        loading:false,
        errorMsg:'',
        passportObj:{
            passportNumber:null,
            passportIssuedCountry:null,
            passportIssuedCountryDetails:null,
            passportExpiryDate:null,
            passportIssuedDate:null,
            documents:[]
        },
        documents:{
            passport : [],
            passportVisaI94:[],
        },
        docslist:[
            {
                key: 'docs_passport',
                fileUploading:false,
                fieldName: 'passport',
                required: true,
                label: 'Passport- First page with photo and last page with address'
            },
            {
                required: false,
                fileUploading:false,
                key: 'docs_passport_visa_i94',
                fieldName: 'passportVisaI94',
                label: 'Passport- First page with photo, Visa page and last page with address'
            },
        ]
    }),
    props: {
        reminderDetails: {
            type: Object,
            default: null,
        },
        reminderId:{
            type: String,
            default: '',
        },
        updateAction:{
            type: String,
            default: '',
        },
        petition: {
            type: Object,
            default: null,
        },
        petitionId:{
            type: String,
            default: '',
        },
    },
    computed:{
        getDocsVal(){
            let returnVal = '';
            if(this.checkProperty(this.passportObj.documents, 'length') > 0){
                returnVal = 'returnVal'
            }
            return returnVal
        }
    }
  };
  </script>